<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <div>
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="4" :sm="24">
              <a-form-item label="名称">
                <a-input v-model="queryParam.template_name" placeholder="请输入名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="2" :xs="6">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-button type="primary" icon="plus" @click="newProcess(undefined)">新建模板</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :pageNum="pageNum"
      :data="loadData"
      :scroll="{ x: 1000 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="version" slot-scope="text">
        <a-tag size="small" color="blue">v{{ text }}</a-tag>
      </div>
      <div slot="status" slot-scope="text">
        <a-tag size="small" :color="text ? 'red' : 'green'"> {{ text ? '已停用' : '已启用' }}</a-tag>
      </div>
      <div slot="category" slot-scope="category">
        <h4>{{ templateCategory(category) }}</h4>
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="editFrom(record)">编辑</a>
          <a-divider type="vertical" v-if="record.is_stop"/>
          <a-popconfirm
            v-if="record.is_stop"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="moveFrom(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="stopFrom(record)">{{ record.is_stop ? '启用' : '停用' }}</a>
        </template>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import draggable from 'vuedraggable'
import {
  groupItemsSort,
  updateGroup, updateForm, createGroup, getForms
} from '@/api/oa_approve'
import { mapMutations } from 'vuex'
import { STable } from '@/components'

export default {
  name: 'FormsPanel',
  components: { STable, draggable },
  data () {
    return {
      queryParam: {},
      moveSelect: '',
      visible: false,
      loading: false,
      groupsSort: false,
      pageNum: 1,
      groups: [],
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'template_name',
          width: 150,
          ellipsis: true
        },
        {
          title: '分类',
          dataIndex: 'category',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'category' }
        },
        {
          title: '版本',
          dataIndex: 'version',
          width: 100,
          scopedSlots: { customRender: 'version' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          dataIndex: 'last_update',
          width: 150,
          ellipsis: true,
          customRender: (text) => (text === '1970-01-01' && '--') || text
        },
        {
          title: '状态',
          dataIndex: 'is_stop',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }

      ],
      loadData: parameter => {
        return getForms(Object.assign(parameter, this.queryParam))
          .then(({ data }) => {
            return data
          })
      }
    }
  },
  computed: {
    templateCategory () {
      return (categories) => {
        return this.getLabelsByValues(categories.split(',')).join('/')
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations('oaApprove', ['setIsEdit']),
    newProcess (groupId) {
      // this.$store.commit('setTemplate', this.getTemplateData())
      // this.$store.commit('setIsEdit', false)
      this.setIsEdit(false)
      if (groupId === undefined) {
        this.$router.push('/oa/approve/form_design')
      } else {
        this.$router.push('/oa/approve/form_design?groupId=' + groupId)
      }
    },
    groupSort () {
      this.groupsSort = false
      groupItemsSort(this.groups).then(rsp => {
        this.$message.success(rsp.data)
        this.$refs.table.refresh(true)
      }).catch(err => {
        this.$refs.table.refresh(true)
        this.$message.error(err.response.data)
      })
    },
    addGroup () {
      this.$prompt('请输入要添加的组名', '新的分组名', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputPattern: /^[\u4E00-\u9FA5A-Za-z0-9\\-]{1,30}$/,
        inputErrorMessage: '分组名不能为空且长度小于30',
        inputPlaceholder: '请输入分组名'
      }).then(({ value }) => {
        createGroup({ name: value }).then(rsp => {
          this.$message.success(rsp.data)
          this.$refs.table.refresh(true)
        }).catch(err => this.$message.error(err.response.data))
      })
    },
    delGroup (group) {
      this.$confirm('删除分组并不会删除表单，表单将会被转移到 “其他” 分组，确定要删除分组 ' + group.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateGroup({ id: group.id }, 'delete').then(rsp => {
          this.$message.success(rsp.data)
          this.$refs.table.refresh(true)
        }).catch(err => this.$message.error(err.response.data))
      })
    },
    editGroup (group) {
      this.$prompt('请输入新的组名', '修改分组名', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputPattern: /^[\u4E00-\u9FA5A-Za-z0-9\\-]{1,30}$/,
        inputErrorMessage: '分组名不能为空且长度小于30',
        inputPlaceholder: '请输入分组名',
        inputValue: group.name
      }).then(({ value }) => {
        updateGroup({ id: group.id, name: value }, group.id).then(rsp => {
          this.$message.success(rsp.data)
          this.$refs.table.refresh(true)
        }).catch(err => this.$message.error(err.response.data))
      })
    },
    updateForm (item, type) {
      if (type === 'delete') {
        updateForm({ is_delete: true }, item.id).then(res => {
          if (res.code === 1000) {
            this.$message.success('删除成功')
            this.$refs.table.refresh(true)
          }
        })
      } else {
        updateForm({ is_stop: !item.is_stop }, item.id).then(rsp => {
          if (rsp.code === 1000) {
            this.$message.success('修改成功')
            this.$refs.table.refresh(true)
          }
        }).catch(err => this.$message.error(err.response.data))
      }
    },
    getTemplateData (data, group) {
      return data
    },
    editFrom (item) {
      // this.$router.push('/admin/design?code=' + item.formId)
      this.$router.push('/oa/approval/templates/create?code=' + item.id)
    },
    stopFrom (item) {
      console.log(item)
      const tip = item.is_stop ? ' 要启用吗？' : ' 要停用吗?'
      this.$confirm('"' + item.template_name + '"' + tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateForm(item, (item.is_stop ? 'using' : 'stop'))
      })
    },
    moveFrom (item) {
      if (item.is_stop) {
        this.$confirm('您确定要删除表单 "' + item.template_name + '" 吗，删除后无法恢复，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updateForm(item, 'delete')
        })
      } else {
        if (this.moveSelect === null || this.moveSelect === '') {
          this.$message.error('请选择分组')
          return
        }
        updateForm({ templateId: item.id, type: 'move', groupId: this.moveSelect }, item.id).then(rsp => {
          if (rsp.code === 1000) {
            this.$message.success('操作成功')
            this.$refs.table.refresh(true)
            this.moveSelect = null
          }
        }).catch(err => this.$message.error(err.response.data))
      }
    },
    getLabelByValue (value, categories = this.$Dictionaries.approval_category) {
      for (const category of categories) {
        if (category.value === value) return category.label
        if (category.children) {
          const result = this.getLabelByValue(value, category.children)
          if (result) return result
        }
      }
      return undefined
    },
    getLabelsByValues (values) {
      const vv = values.map((value) => {
        const v = this.getLabelByValue(Number(value))
        return v
      }).filter((value) => value !== undefined)
      return vv
    }
  }
}
</script>

<style lang="less" scoped>
body {
  background: #ffffff !important;
}

.undrag {
  background: #ffffff !important;
}

.from-panel {
  padding: 50px 100px;
  min-width: 500px;
  background: #ffffff;

  /deep/ .from-title {
    div {
      float: right;

      .el-button {
        border-radius: 15px;
      }
    }
  }

  //height: 100vh;
}

.choose {
  background: #e9ebee;
}

.form-group {
  margin: 20px 0;
  padding: 5px 0px;
  border-radius: 10px;
  //border: 1px solid #d3d3d3;
  box-shadow: 1px 1px 10px 0 #d2d2d2;

  &:hover {
    box-shadow: 1px 1px 12px 0 #b3b3b3;
  }

  .form-group-title {
    padding: 5px 20px;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #d3d3d3;

    .el-icon-rank {
      display: none;
      cursor: move;
    }

    &:hover {
      .el-icon-rank {
        display: inline-block;
      }
    }

    div {
      display: inline-block;
      float: right;
    }

    span:first-child {
      margin-right: 5px;
      font-size: 15px;
      font-weight: bold;
    }

    span:nth-child(2) {
      color: #656565;
      font-size: small;
      margin-right: 10px;
    }

    /deep/ .el-button {
      color: #404040;
      margin-left: 20px;

      &:hover {
        color: #2b2b2b;
      }
    }
  }

  .form-group-item:nth-child(1) {
    border-top: none !important;
  }

  .form-group-item {
    color: #3e3e3e;
    font-size: small;
    padding: 10px 0;
    margin: 0 20px;
    height: 40px;
    position: relative;
    line-height: 40px;
    //border-bottom: 1px solid #d3d3d3;

    div {
      display: inline-block;
    }

    i {
      border-radius: 10px;
      padding: 7px;
      font-size: 20px;
      color: #ffffff;
      margin-right: 10px;
    }

    div:nth-child(1) {
      float: left;
      max-width: 200px;
      white-space: nowrap; /* 强制文本不换行 */
      overflow: hidden;    /* 隐藏溢出内容 */
      text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
      width: 200px;         /* 设置一个具体的宽度或最大宽度 */
      display: block;
    }

    div:nth-child(2) {
      position: absolute;
      color: #7a7a7a;
      font-size: 12px;
      left: 260px;
      max-width: 300px;
      overflow: hidden;
    }
    div:nth-child(3) {
      position: absolute;
      right: 35%;
    }
    div:nth-child(4) {
      position: absolute;
      right: 15%;
    }

    div:nth-child(5) {
      float: right;
    }
  }
}

@media screen and (max-width: 1000px) {
  .desp {
    display: none !important;
  }
}

@media screen and (max-width: 800px) {
  .from-panel{
    padding: 50px 10px;
  }
}
</style>
